export default __webpack_public_path__ + "static/media/Asset---3.d4210eb2.png";